module.exports = __webpack_public_path__ + "static/img/vip_fnb_qr.6094874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip_fnb_qr.png
// module id = 2hrZ
// module chunks = 0